import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

import { AccountingAccessService } from '../../../../services/accounting-access.service';

@Directive({
  selector: '[rnplAccountingWriteAccess]'
})
export class AccountingWriteAccessDirective implements OnInit, OnDestroy {

  @Input() rnplAccountingWriteAccess = true;

  private readonly clickHandler = (event: MouseEvent): void => {
    if (!this.rnplAccountingWriteAccess || !this.accountingAccessService.denyWriteAccess()) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  };

  constructor(
    private readonly elementRef: ElementRef,
    private readonly accountingAccessService: AccountingAccessService,
  ) {}

  ngOnInit(): void {
    this.elementRef.nativeElement.addEventListener('click', this.clickHandler, true);
  }

  ngOnDestroy(): void {
    this.elementRef.nativeElement.removeEventListener('click', this.clickHandler, true);
  }
}
